import { usePrefs, useLabels } from 'wsm-common-data';

export const useVehicleTabs = (tabComponents) => {
	const {
		showInformationTabs,
		tabInfoLabel,
		tabPricingLabel,
		tabSpecialsLabel
	} = usePrefs();

	const labels = useLabels();

	const tabLabels = {
		info: labels.get(tabInfoLabel),
		specials: labels.get(tabSpecialsLabel),
		pricing: labels.get(tabPricingLabel)
	};

	if (!showInformationTabs) return { tabArray: [], tabLabels };

	const orderedTabs = showInformationTabs
		.replace(/\s/g, '')
		.toLowerCase()
		.split(',');

	const tabArray = orderedTabs
		.filter((key) => tabComponents[key])
		.map((key) => ({
			eventKey: key,
			key,
			title: tabLabels[key],
			component: tabComponents[key]
		}));

	return { tabArray, tabLabels };
};
